// Compatibility layer to support old components while transitioning to new API
import { Event as NewEvent, apiService } from './api';

// Legacy Event interface for backward compatibility
export interface LegacyEvent {
  id: string;
  title: string;
  description: string;
  location: string;
  dateTime: string;
  price: number;
  maxAttendees: number;
  availableTickets?: number;
  imageUrl?: string;
}

// Convert new Event to legacy format
const convertToLegacyEvent = (event: NewEvent): LegacyEvent => {
  // Use the first ticket category's price as the main price
  const firstCategory = event.ticketCategories?.[0];
  const price = firstCategory?.price || 0;
  
  return {
    id: event.id,
    title: event.title,
    description: event.description,
    location: event.location,
    dateTime: event.startDateTime || new Date().toISOString(),
    price: price,
    maxAttendees: event.maxAttendees || 0,
    availableTickets: event.maxAttendees || 0,
    imageUrl: event.medias?.[0]?.url
  };
};

// Legacy API service wrapper
export const legacyApiService = {
  async getEvents(): Promise<LegacyEvent[]> {
    const events = await apiService.getEvents();
    return events.map(convertToLegacyEvent);
  },

  async getEventById(id: string): Promise<LegacyEvent> {
    const event = await apiService.getEvent(id);
    return convertToLegacyEvent(event);
  },

  // Delegate other methods to the new API service
  purchaseTicket: apiService.purchaseTicket.bind(apiService),
  validateTicket: apiService.validateTicket.bind(apiService)
};
